<script lang="ts" setup>
import type { AssistantQuestion } from './types';

const props = defineProps<{
  disabled: boolean;
  questions: AssistantQuestion[];
}>();

const emit = defineEmits<{
  send: [question: string];
}>();
</script>

<template>
  <div v-if="props.questions.length > 0" class="flex flex-shrink-0 flex-wrap gap-8 px-18 py-12">
    <button
      v-for="question in props.questions"
      :key="question.id"
      type="button"
      class="h-32 cursor-pointer border-1 border-#C7E1FF rounded-full border-solid bg-#F4F9FF px-12 text-13 text-#1281FF font-500 disabled:cursor-not-allowed disabled:opacity-55"
      :disabled="props.disabled"
      @click="emit('send', question.prompt)"
    >
      {{ question.prompt }}
    </button>
  </div>
</template>
